import AsyncSelect from 'react-select/async';
import { getRandomUid } from 'utilities/uuid.service';
import { useMemo } from 'react';
import { questionIssues } from 'utilities/constants';

function QuestionIssuesList({ isMulti, values, handleChange }) {
  const _id = getRandomUid();

  const defaultOptions = useMemo(() => {
    const array = [];
    for (const [key, value] of Object.entries(questionIssues)) {
      array.push({ label: value, value: key });
    }
    return array;
  }, []);

  return (
    <>
      <label htmlFor={_id}>Error part *</label>
      <div className="position-relative">
        <AsyncSelect
          inputId={_id}
          isMulti={isMulti}
          cacheOptions
          onChange={handleChange}
          defaultOptions={defaultOptions}
          value={values}
        />
      </div>
    </>
  );
}

QuestionIssuesList.defaultProps = {
  values: [],
  isMulti: true,
  handleChange: () => {},
};

export default QuestionIssuesList;
